import React from "react";
import {
    Badge
} from 'reactstrap';
import {appHelpers} from "../../_helpers";
import ToolTipItem from "../utils/tooltip";
 import IconMdAirplanemodeActive from 'react-icons/lib/md/airplanemode-active';
 import IconRemove from 'react-icons/lib/md/delete-sweep';

class OutstandingAirlinesList extends React.Component {
    render() {
        let { data, removeOutstandingAirline } = this.props;
         return (
            <div>
                {data.map((item, i) =>
                    <span key={i}>
                        <Badge className='mr-2 mb-1 p-2 clearfix' color='warning'>
                            <div className="pull-left mr-1">
                                <IconMdAirplanemodeActive size="30" color="#ffffff"/>
                            </div>
                            <div className="pull-right">
                                <div className='mb-2'>
                                    <ToolTipItem key={i + 'OutstandingAirline'} title={item.OutstandingAirline} content='Airline' id={i + 'OutstandingAirline'}/>
                                    {
                                        (item.OutstandingAirport) &&
                                        <span>
                                            &nbsp; - &nbsp;
                                            <ToolTipItem key={i + 'OutstandingAirport'} title={item.OutstandingAirport} content='Station' id={i + 'OutstandingAirport'}/>
                                        </span>
                                    }
                                </div>
                                 <div className='mb-2 text-left'>
                                     <ToolTipItem key={i + 'OutstandingFlightStartDate'} title={appHelpers.formatDateSpecific(item.OutstandingFlightStartDate, 'DD, MMM YYYY')} content='Flight Start Date' id={i + 'OutstandingFlightStartDate'}/>
                                     &nbsp;-&nbsp;
                                     <ToolTipItem key={i + 'OutstandingFlightEndDate'} title={appHelpers.formatDateSpecific(item.OutstandingFlightEndDate, 'DD, MMM YYYY')} content='Flight End Date' id={i + 'OutstandingFlightEndDate'}/>
                                 </div>
                                <div className='text-left'>
                                    <ToolTipItem key={i + 'OutstandingROE'} title={item.OutstandingROE} content='ROE' id={i + 'OutstandingROE'}/>
                                    &nbsp;&nbsp;
                                    <span onClick={() => removeOutstandingAirline(i)} className='text-danger pointer'>
                                         <IconRemove size="16" color="#ff1f1f"/> Remove
                                    </span>
                                </div>
                            </div>
                            </Badge>
                    </span>
                )}
            </div>
        )
    }
}
export default OutstandingAirlinesList;



// WEBPACK FOOTER //
// ./src/views/proforma/outstandling-airlines-list.js